import { jsx as e } from "react/jsx-runtime";
import { SupercashbackTag as c } from "./components/SupercashbackTag/index.js";
import { SupercashbackPercentageTag as t } from "./components/SupercashbackPercentageTag/index.js";
import { CashbackPercentagePill as s } from "./components/CashbackPercentagePill/index.js";
const h = ({ type: r, ...a }) => {
  switch (r) {
    case "supercashback":
      return /* @__PURE__ */ e(c, { ...a });
    case "supercashback-percentage":
      return /* @__PURE__ */ e(t, { ...a });
    case "pill":
      return /* @__PURE__ */ e(s, { ...a });
    default:
      return null;
  }
};
export {
  s as CashbackPercentagePill,
  h as CashbackTag,
  t as SupercashbackPercentageTag,
  c as SupercashbackTag
};
